import { COMPANY, CUSTOM_SECURITY, INDEX, INDICATOR, MODEL_PORTFOLIO, MUTUAL_FUND, SEPARATE_ACCOUNT, } from 'Angular/constants/core.constants';
import { FundChartSeriesType, } from 'ChartApp/ts/interfaces/fund-chart.interface';
import { getSecurityTypeFromId } from 'Angular/utils/security-utils';
export const FUND_CHART_CURRENCY_CHANGED_EVENT = 'Changed Fund Chart Currency';
// Every count is always present so the event's property set is stable in Pendo
const SECURITY_COUNT_TYPES = [
    COMPANY,
    MUTUAL_FUND,
    INDEX,
    INDICATOR,
    MODEL_PORTFOLIO,
    SEPARATE_ACCOUNT,
    CUSTOM_SECURITY,
    FundChartSeriesType.securityList,
];
export const getSecurityCountsByType = (fundChart) => {
    const counts = Object.fromEntries(SECURITY_COUNT_TYPES.map((type) => [`num_${type}`, 0]));
    // The state's securities are typed as plain securities while securitylist entries ride along at runtime
    const securities = fundChart?.securities ?? [];
    securities.forEach((security) => {
        const type = security.type === FundChartSeriesType.securityList
            ? FundChartSeriesType.securityList
            : getSecurityTypeFromId(security.id);
        const key = `num_${type}`;
        if (key in counts) {
            counts[key] += 1;
        }
    });
    return counts;
};
/**
 * Fires the Pendo event for a currency pick in the Convert Currency flyout, describing the chart it was made on.
 */
export const trackFundChartCurrencyChange = (fundChart, newCurrency) => {
    window.pendoTrack(FUND_CHART_CURRENCY_CHANGED_EVENT, {
        previous_currency: fundChart?.currency ?? null,
        new_currency: newCurrency,
        chart_id: fundChart?.chartId ?? null,
        data_format: fundChart?.format ?? null,
        ...getSecurityCountsByType(fundChart),
    });
};
